import { apiRequest } from "@/api";

const state = {
  pages: 0,
  showing: false,
};

const actions = {
  EXPORT_USERS: ({ state }, params) => {
    return new Promise((resolve, reject) => {
      apiRequest()
        .post("export_system/export_users", params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => {
          console.log(e);
          reject(e);
        });
    });
  },
  EXPORT_MESSAGES_PAGES: ({ state }, type) => {
    return new Promise((resolve, reject) => {
      apiRequest()
        .get(`export_system/export_pages?type=${type}`)
        .then(({ data }) => {
          state.pages = data.pages;
          resolve(data);
        })
        .catch((e) => {
          console.log(e);
          reject(e);
        });
    });
  },
  EXPORT_MESSAGES: ({ state }, params) => {
    return new Promise((resolve, reject) => {
      apiRequest()
        .post("export_system/export_messages", params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => {
          console.log(e);
          reject(e);
        });
    });
  },
};

const mutations = {};

export default {
  state,
  actions,
  mutations,
};
